import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@homeexchange/design';

const Accordion = (props) => (
    <div className="panel panel-default accordion">
        <a data-toggle="collapse" href={`#${props.id}`}>
            <div className="panel-heading">
                <div className="panel-title">{props.title}</div>
                <Icon name="ChevronDown" className="down-arrow" />
            </div>
        </a>
        <div id={props.id} className="panel-collapse collapse">
            <div
                className="panel-body"
                dangerouslySetInnerHTML={{
                    __html: props.description
                }}
            />
        </div>
    </div>
);

Accordion.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default Accordion;
